export default {"src":"/_next/static/media/Dex-Badge-Light.d4407d47.gif","height":850,"width":1200};